import USERS_SNAPSHOT from '../../rental-portal-mock-data/users.json'

const RENTAL_PORTAL_MOCK_MEDIA_CONTEXT = require.context(
  '../../rental-portal-mock-data/media',
  true,
  /\.(pdf|svg)$/
)

const RENTAL_PORTAL_MOCK_MEDIA_PREFIX = 'media/'

const RENTAL_PORTAL_MOCK_EXTRA_AVATAR_COLORS = ['#B58A2E', '#4E8FA8']

export const RENTAL_PORTAL_MOCK_MEDIA_URL_BY_PATH = new Map(
  RENTAL_PORTAL_MOCK_MEDIA_CONTEXT.keys().map(key => [
    key.replace(/^\.\//, RENTAL_PORTAL_MOCK_MEDIA_PREFIX),
    RENTAL_PORTAL_MOCK_MEDIA_CONTEXT(key),
  ])
)

export const RENTAL_PORTAL_MOCK_AVATAR_COLORS = [
  ...USERS_SNAPSHOT.map(user => user.avatar_color),
  ...RENTAL_PORTAL_MOCK_EXTRA_AVATAR_COLORS,
]
